import React from 'react';
import { Badge } from 'react-bootstrap';
import { LoadingError } from '../../LoadingError';
import { LoadingSpinner } from '../../LoadingSpinner';
import { Block, IBlockLinkProps } from '../Block';
import './index.scss';
import { useMembership } from '../../../hooks/useMembership';

interface IMembershipBlock {
    link?: IBlockLinkProps;
    callToAction?: React.ReactNode;
}

const MembershipBlock: React.FC<IMembershipBlock> = ({ link, callToAction }) => {
    const { models, operations } = useMembership();
    const { membership, error, loading } = models;
    const { formattedExpiryDate } = operations;
    const hasActiveAutoRenewal = (membership?.subscriptionId?.length ?? 0) > 0;

    return (
        <Block title="Membership" bg="lime" fill="lime" link={link} callToAction={callToAction}>
            {loading && <LoadingSpinner />}
            {error && <LoadingError />}
            {!loading && !error && (
                <>
                    <div className="membership-block-badge-container d-flex justify-content-between">
                        <div className="small">
                            <b>{membership?.type}</b>
                        </div>
                        <div>
                            {hasActiveAutoRenewal && <Badge pill>Auto Renew</Badge>}
                        </div>
                    </div>

                    <div className="membership-block-membershipnumber">{membership?.number}</div>

                    <div className="small me-2 mt-2">
                        <b>Renews {formattedExpiryDate(new Date(membership?.endDate))}</b>
                        {!membership?.active && (
                            <Badge
                                pill
                                bg={'warning'}
                                className="ms-2"
                                style={{
                                    fontSize: '.75em',
                                    fontWeight: 'thin',
                                    opacity: '.5',
                                }}
                            >
                                Renewal is pending
                            </Badge>
                        )}
                    </div>
                </>
            )}
        </Block>
    );
};

export default MembershipBlock;
